import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const sushiswapToken = '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2'
// Define a service using a base URL and expected endpoints
export const sushiswapApi = createApi({
  reducerPath: 'getSushiswap',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api2.sushipro.io' }),
  endpoints: builder => ({
    getSushiswap: builder.query<Array<any>, string | null>({
      query: (token: string | null) =>
        token
          ? `?chainID=1&action=get_pairs_by_token&token=${token}`
          : `?chainID=1&action=get_pairs_by_token&token=${sushiswapToken}`,
      transformResponse: (response: any) => {
        return response[1].slice(0, 100)
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSushiswapQuery } = sushiswapApi
